import type { CallDebugInfo } from 'Modules/softphone/services/DebugService';

/**
 * The interaction a record belongs to.
 *
 * A leg with no `interactionId` is an interaction of one — a plain call that
 * was never transferred or merged.
 */
export const getInteractionId = (info: CallDebugInfo): string =>
  info.interactionId ?? info.callId;

/**
 * How many captured legs belong to the same interaction as `info`.
 *
 * Drives the "All N legs" download: a warm transfer or a conference is not
 * diagnosable one leg at a time.
 */
export const countInteractionLegs = (
  history: CallDebugInfo[],
  info: CallDebugInfo
): number =>
  history.filter((entry) => getInteractionId(entry) === getInteractionId(info))
    .length;
